import React from 'react';
import { Controller, SubmitHandler, UseFormReturn } from 'react-hook-form';
import { OTPFormType } from 'entities/sendOTP/types';
import { useGetCountriesQuery } from 'features/getCountries/api/getCountriesApi';
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
} from '@mui/material';
import { useGetAvailableQuery } from 'entities/sendOTP/api';

type OTPCardPropsType = {
  form: UseFormReturn<OTPFormType>;
  onSubmit: (data: OTPFormType) => SubmitHandler<OTPFormType>;
  textButton: string;
};

export const OtpCard = ({ form, onSubmit, textButton }: OTPCardPropsType) => {
  const { data: countryList, isSuccess: countrySuccess } = useGetCountriesQuery(null);
  const { data: availableList, isSuccess: availableSuccess } = useGetAvailableQuery(null);
  const { control, handleSubmit, formState: { errors = {} } = {} } = form;
  const priorityValues = [0, 1, 2, 3];

  return (
    <div>
      {countrySuccess && (
        <Controller
          control={control}
          name="country_id"
          render={({ field }) => (
            <FormControl
              fullWidth
              sx={{ marginBottom: '24px' }}
              error={!!errors.country_id}
            >
              <InputLabel id="select-label">Страна*</InputLabel>
              <Select
                labelId="simple-select-label"
                id="simple-select"
                label="Страна*"
                {...field}
              >
                {countryList.map((country) => (
                  <MenuItem value={country.id}>{country.name}</MenuItem>
                ))}
              </Select>
              <FormHelperText>{errors.country_id && errors.country_id.message}</FormHelperText>
            </FormControl>
          )}
        />
      )}
      {availableSuccess && (
        <Controller
          control={control}
          name="displayed_name"
          render={({ field }) => (
            <FormControl
              fullWidth
              sx={{ marginBottom: '24px' }}
              error={!!errors.displayed_name}
            >
              <InputLabel id="select-label">Способ отправки*</InputLabel>
              <Select
                labelId="simple-select-label"
                id="simple-select"
                label="Способ отправки*"
                {...field}
              >
                {availableList.map((available) => (
                  <MenuItem value={available.displayed_name}>{available.displayed_name}</MenuItem>
                ))}
              </Select>
              <FormHelperText>{errors.displayed_name && errors.displayed_name.message}</FormHelperText>
            </FormControl>
          )}
        />
      )}

      <Controller
        control={control}
        name="priority"
        render={({ field }) => (
          <FormControl
            fullWidth
            sx={{ marginBottom: '24px' }}
            error={!!errors.priority}
          >
            <InputLabel id="select-label">Приоритет*</InputLabel>
            <Select
              labelId="simple-select-label"
              id="simple-select"
              label="Приоритет*"
              {...field}
            >
              {priorityValues.map((value) => (
                <MenuItem
                  key={value}
                  value={value}
                >
                  {value}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{errors.priority && errors.priority.message}</FormHelperText>
          </FormControl>
        )}
      />
      <Controller
        control={control}
        name="limit_per_day"
        render={({ field, fieldState }) => (
          <TextField
            fullWidth
            label="Лимит на сутки*"
            type="number"
            sx={{ marginBottom: '24px' }}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            onKeyPress={(event) => {
              const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
              if (!allowedKeys.includes(event.key)) {
                event.preventDefault();
              }
            }}
            onPaste={(event) => {
              event.preventDefault();
            }}
            {...field}
          />
        )}
      />
      <Controller
        control={control}
        name="limit_per_month"
        render={({ field, fieldState }) => (
          <TextField
            fullWidth
            label="Лимит на месяц*"
            type="number"
            sx={{ marginBottom: '24px' }}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            onKeyPress={(event) => {
              const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
              if (!allowedKeys.includes(event.key)) {
                event.preventDefault();
              }
            }}
            onPaste={(event) => {
              event.preventDefault();
            }}
            {...field}
          />
        )}
      />
      <Controller
        control={control}
        name="retry_time"
        render={({ field, fieldState }) => (
          <TextField
            fullWidth
            label="Минуты*"
            type="number"
            sx={{ marginBottom: '24px' }}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            onKeyPress={(event) => {
              const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
              if (!allowedKeys.includes(event.key)) {
                event.preventDefault();
              }
            }}
            onPaste={(event) => {
              event.preventDefault();
            }}
            {...field}
          />
        )}
      />
      <Controller
        control={control}
        name="is_enabled"
        render={({ field }) => (
          <Box sx={{ marginBottom: '24px' }}>
            Включено
            <Switch
              sx={{ marginLeft: '15px' }}
              checked={field.value}
              {...field}
            />
          </Box>
        )}
      />
      <Button
        variant="contained"
        onClick={handleSubmit(onSubmit)}
      >
        {textButton}
      </Button>
    </div>
  );
};
